/** @format */

import React from "react";
import WithModal from "./WithModal";
import ModalIframeCarousel from "./ModalIframeCarousel";
import _ from "lodash";
import { TitledIframe } from "./TitledIframe";
import { ButtonLinkButton, ButtonOrLinkOnMobile } from "./LinkButtons";
import { smallOriOS } from "../Utils";

const OtherVideoLinkOne = WithModal(
  ({ title, buttonTitle, src, path, ...props }) => {
    if (!src) return null;
    return (
      <>
        <ButtonOrLinkOnMobile
          onClick={props.showModal}
          href={src}
          buttonTitle={buttonTitle}
        />
        {props.modalContent(
          <TitledIframe src={src} title={title} width={853} height={480} />,
          {
            showCloseIcon: true,
            trackPath: path,
            modalStyles: {
              maxWidth: "1000px",
              top: "50%",
              marginTop: "calc( -240px - 1.2rem )",
            },
          },
        )}
      </>
    );
  },
);

const OtherVideoModalMobile = WithModal(
  ({ videos, titleStart, trackPathStart, ...props }) => {
    if (!videos || videos.length === 0) return null;

    let buttonTitle = videos[0].title;
    if (videos.length > 1) buttonTitle = "Videos";
    return (
      <>
        <ButtonLinkButton onClick={props.showModal} buttonTitle={buttonTitle} />
        {props.modalContent(
          <div style={{ marginTop: "2em", marginBottom: "1em" }}>
            <div style={{ marginTop: "1em" }}>
              {titleStart}
              <br />
              Videos
            </div>
            <div className="docButtonList">
              {_.sortBy(videos, "title").map((mp, idx) => (
                <React.Fragment>
                  <OtherVideoLinkOne
                    key={mp.url}
                    title={_.trim(
                      `${titleStart} ${mp.title}  ${
                        mp.title
                          ? ""
                          : "(" + (idx + 1) + " of " + videos.length + ")"
                      }`,
                    )}
                    titleStart={titleStart}
                    buttonTitle={_.trim(
                      `${titleStart} ${
                        mp.title ||
                        " (" + (idx + 1) + " of " + videos.length + ")"
                      }`,
                    )}
                    src={mp.url}
                    path={trackPathStart + (mp.title ? `/${mp.title}` : "")}
                    {...props}
                  />
                  <br />
                </React.Fragment>
              ))}
            </div>
          </div>,
          {
            showCloseIcon: true,
            //trackPath: path,
            modalStyles: {
              maxWidth: "90%",
              width: "90%",
              //height: "100%"
            },
          },
        )}
      </>
    );
  },
);

const OtherVideoCarouselLink = WithModal(
  ({ videos, titleStart, trackPathStart, ...props }) => {
    if (!videos || videos.length === 0) return null;

    let buttonTitle = videos[0].title;
    if (videos.length > 1) buttonTitle = "Videos";
    return (
      <>
        <ButtonLinkButton onClick={props.showModal} buttonTitle={buttonTitle} />
        {props.modalContent(
          <ModalIframeCarousel
            items={_.sortBy(videos, "title")}
            getSrc={(mp) => mp.url}
            getTitle={(mp) => _.trim(`${titleStart} ${mp.title}`)}
            getTrackPath={(mp) => `${trackPathStart}/${mp.title}`}
          />,
          {
            showCloseIcon: true,
            //trackPath: path,
            modalStyles: {
              maxWidth: "90%",
              width: "90%",
              height: "100%",
            },
          },
        )}
      </>
    );
  },
);

// TODO - remove screenIsSmall (false), probably also remove space and ...props because they aren't used anymore.
// TODO - are we using trackPath anymore?
const OtherVideoLink = ({ property, space, ...props }) => {
  let titleStart = "";
  let videos;
  let trackPathStart;
  if (space) {
    titleStart = `${property.externalName || property.name} Suite ${
      space.suite
    }`;
    trackPathStart = `${property.wtweb_id}/${space.suite}/video`;
    videos = space.other_videos;
  } else if (property) {
    titleStart = property.externalName || property.name;
    trackPathStart = `${property.wtweb_id}/video`;
    videos = property.other_videos;
  }
  if (!videos || videos.length === 0) return null;

  if (!smallOriOS(false))
    return (
      <OtherVideoCarouselLink
        videos={videos}
        titleStart={titleStart}
        trackPathStart={trackPathStart}
        {...props}
      />
    );
  else {
    if (videos.length === 1) {
      const v = videos[0];
      // Just link
      return (
        <OtherVideoLinkOne
          key={v.url}
          title={`${titleStart} ${v.title}`}
          buttonTitle={v.title}
          src={v.url}
          path={`${trackPathStart}/${v.title}`}
        />
      );
    } else {
      // Modal of multiple plain links
      return (
        <OtherVideoModalMobile
          videos={videos}
          titleStart={titleStart}
          trackPathStart={trackPathStart}
        />
      );
    }
  }
};

export default OtherVideoLink;
